import { render, staticRenderFns } from "./SummaryView.vue?vue&type=template&id=59567adb&scoped=true"
import script from "./SummaryView.vue?vue&type=script&lang=ts"
export * from "./SummaryView.vue?vue&type=script&lang=ts"
import style0 from "./SummaryView.vue?vue&type=style&index=0&id=59567adb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59567adb",
  null
  
)

export default component.exports